import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import type { ControlledFieldProps, FormFieldBaseProps } from '../../types'
import styles from './File.module.scss'

type FileProps = FormFieldBaseProps & {
  accept?: string
  multiple?: boolean
  value?: string
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  onChange?: React.ChangeEventHandler<HTMLInputElement>
}

export const File = React.forwardRef<HTMLInputElement, FileProps>(
  (
    {
      accept,
      error,
      fieldClassName,
      id,
      multiple,
      name,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isRequired = false,
    },
    ref,
  ) => (
    <input
      className={cx(styles.file, fieldClassName, {
        [styles.invalid]: Boolean(error),
      })}
      type="file"
      disabled={isDisabled}
      required={isRequired}
      {...{
        accept,
        id,
        multiple,
        name,
        ref,
        value,
        onBlur,
        onChange,
      }}
    />
  ),
)

type ControlledFileProps = ControlledFieldProps &
  Pick<FileProps, 'accept' | 'multiple'>

export const ControlledFile = ({
  accept,
  control,
  error,
  fieldClassName,
  id,
  multiple,
  name,
  isDisabled,
  isRequired,
}: ControlledFileProps) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <File
        value={value?.fileName}
        onChange={event => onChange(event.target.files)}
        {...{
          accept,
          error,
          fieldClassName,
          id,
          multiple,
          name,
          ref,
          onBlur,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
